import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import './_style.scss';
import { Dropdown } from 'react-bootstrap';
import { DropdownWrapper } from '../../atoms/DropdownWrapper/DropdownWrapper';
import { profileImageUrl } from '../../../helpers/urls';
import { initLogoutAction } from '../../../actions/authActions';

const PageHeader = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  return (
    <header className='header'>
      <div className='logo hidden-lg-down'>
        <Link to='/working-hours'>
          <img className='logo-img' src='/img/team_time_logo.svg' alt='Logo' />
          <span className='logo-text'>Team Time</span>
        </Link>
      </div>
      <div className='user-info-container'>
        <Dropdown>
          <Dropdown.Toggle as={DropdownWrapper} className='dropdown'>
            <div className='user__info' data-toggle='dropdown'>
              <img className='user__img' src={profileImageUrl(user)} alt='' />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Link to='/working-hours' component={Dropdown.Item}>
              Working Hours
            </Link>
            {user.is_admin && (
              <>
                <Link to='/controlling' component={Dropdown.Item}>
                  Controlling
                </Link>
                <Link to='/employees' component={Dropdown.Item}>
                  Employees
                </Link>
              </>
            )}
            <Dropdown.Item onClick={() => dispatch(initLogoutAction())}>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
};

export default PageHeader;
